import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MapSiteBoundariesDirective } from './map-site-boundaries.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [MapSiteBoundariesDirective],
    exports: [MapSiteBoundariesDirective]
})
export class SitesSharedModule {}
